/* eslint-disable react/jsx-curly-newline */
import { Button, Modal, message } from 'antd';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { BoxInput } from '../../../styles';
import { api } from '../../../../../services/api';

export function ModalAddProductQuestion({
  productId,
  isModalOpen,
  setIsModalOpen,
  getProduct,
}) {
  const [addSubquestionLoading, setAddSubquestionLoading] = useState(false);
  const [questionName, setQuestionName] = useState('');
  const [questionObservation, setQuestionObservation] = useState('');
  const [questionLimiteCaracteries, setQuestionLimiteCaracteries] =
    useState('');
  const [questionScore, setQuestionScore] = useState('');

  const [messageApi, contextHolder] = message.useMessage();
  const [messageError, setMessageError] = useState(null);

  function clearNumber(priceInput) {
    return Number(String(priceInput).replace('.', ''));
  }

  function formatNumber(priceInput) {
    return (Number(clearNumber(priceInput)) / 100).toFixed(2);
  }

  async function productQuestionActions() {
    if (!questionScore || !questionName || !questionLimiteCaracteries) {
      messageApi.open({
        type: 'error',
        content: 'Todos os campos são obrigatórios',
      });

      return;
    }

    try {
      setAddSubquestionLoading(true);

      await api.post(`/products/product-questions/${productId}`, {
        title: questionName,
        character_limit: questionLimiteCaracteries,
        score: questionScore,
        observation: questionObservation,
      });

      setQuestionName('');
      setQuestionLimiteCaracteries('');
      setQuestionScore('');
      setQuestionObservation('');
      toast.success('Questão criada com sucesso');
      getProduct();
      setAddSubquestionLoading(false);
      setIsModalOpen(false);
      setMessageError(null);
    } catch (error) {
      setMessageError(error.response.data.message);
      toast.error('Erro ao cadastrar questão');
      setAddSubquestionLoading(false);
    }
  }

  return (
    <>
      <Modal
        title="Adicionar questão"
        open={isModalOpen}
        footer={null}
        onCancel={() => setIsModalOpen(false)}
        width={700}
      >
        <BoxInput style={{ marginTop: 30 }}>
          <label htmlFor="questionName">Título</label>
          <input
            id="questionName"
            type="text"
            name="questionName"
            placeholder="Título da questão"
            value={questionName}
            onChange={(event) => setQuestionName(event.target.value)}
          />
        </BoxInput>

        <BoxInput>
          <label htmlFor="questionLimiteCaracteries">
            Limite de caracteries
          </label>
          <input
            id="questionLimiteCaracteries"
            type="number"
            name="questionLimiteCaracteries"
            placeholder="Limite de caracteries da questão"
            value={questionLimiteCaracteries}
            onChange={(event) =>
              setQuestionLimiteCaracteries(event.target.value)
            }
          />
        </BoxInput>

        <BoxInput>
          <label htmlFor="questionScore">Nota máxima</label>
          <input
            id="questionScore"
            type="text"
            name="questionScore"
            placeholder="Nota máxima da questão"
            value={questionScore}
            onChange={(event) =>
              setQuestionScore(formatNumber(event.target.value))
            }
          />
        </BoxInput>

        <BoxInput style={{ marginTop: 30 }}>
          <label htmlFor="observation">Observação</label>
          <input
            id="observation"
            type="text"
            name="observation"
            placeholder="Observação da questão"
            value={questionObservation}
            onChange={(event) => setQuestionObservation(event.target.value)}
          />
        </BoxInput>

        <div style={{ textAlign: 'center', marginTop: 50 }}>
          {messageError && (
            <span style={{ marginBottom: 20, color: 'red', display: 'block' }}>
              {messageError}
            </span>
          )}
          <Button
            type="primary"
            onClick={() => productQuestionActions()}
            loading={addSubquestionLoading}
          >
            Adicionar questão
          </Button>
        </div>
      </Modal>
      {contextHolder}
    </>
  );
}
